module.exports = __webpack_public_path__ + "img/proyecto_15.127324b2.webp";